/* WEAPON_NAMES:START */
const GENSHEIN_WEAPON_NAMES = {
  "11501": "Aquila Favonia",
  "11502": "Skyward Blade",
  "11503": "Freedom-Sworn",
  "11504": "Summit Shaper",
  "11505": "Primordial Jade Cutter",
  "11509": "Mistsplitter Reforged",
  "11510": "Haran Geppaku Futsu",
  "11511": "Key of Khaj-Nisut",
  "11512": "Light of Foliar Incision",
  "11513": "Splendor of Tranquil Waters",
  "11514": "Uraku Misugiri",
  "11515": "Absolution",
  "11516": "Peak Patrol Song",
  "11518": "Athame Artis",
  "11519": "Lightbearing Moonshard",
  "12501": "Skyward Pride",
  "12502": "Wolf's Gravestone",
  "12503": "Song of Broken Pines",
  "12504": "The Unforged",
  "12510": "Redhorn Stonethresher",
  "12511": "Beacon of the Reed Sea",
  "12512": "Verdict",
  "12514": "A Thousand Blazing Suns",
  "13501": "Staff of Homa",
  "13502": "Skyward Spine",
  "13504": "Vortex Vanquisher",
  "13505": "Primordial Jade Winged-Spear",
  "13507": "Calamity Queller",
  "13509": "Engulfing Lightning",
  "13511": "Staff of the Scarlet Sands",
  "13512": "Crimson Moon's Semblance",
  "13513": "Lumidouce Elegy",
  "13514": "Symphonist of Scents",
  "13517": "Disaster and Remorse",
  "14501": "Skyward Atlas",
  "14502": "Lost Prayer to the Sacred Winds",
  "14504": "Memory of Dust",
  "14505": "Jadefall's Splendor",
  "14506": "Everlasting Moonglow",
  "14509": "Kagura's Verity",
  "14511": "A Thousand Floating Dreams",
  "14512": "Tulaytullah's Remembrance",
  "14513": "Cashflow Supervision",
  "14514": "Tome of the Eternal Flow",
  "14515": "Crane's Echoing Call",
  "14517": "Starcaller's Watch",
  "14518": "Sunny Morning Sleep-In",
  "14519": "Vivid Notions",
  "14520": "Nightweaver's Looking Glass",
  "14521": "Reliquary of Truth",
  "14523": "Angelos' Heptades",
  "15501": "Skyward Harp",
  "15502": "Amos' Bow",
  "15503": "Elegy for the End",
  "15507": "Polar Star",
  "15508": "Aqua Simulacra",
  "15509": "Thundering Pulse",
  "15511": "Hunter's Path",
  "15512": "The First Great Magic",
  "15513": "Silvershower Heartstrings",
  "15514": "Astral Vulture's Crimson Plumage",
  "15516": "Golden Frostbound Oath",
  "192515": "Gest of the Mighty Wolf",
  "193516": "Bloodsoaked Ruins",
  "194522": "Nocturne's Curtain Call"
};
/* WEAPON_NAMES:END */

/*
  Genshin Impact Catalog - Shopify Integration
  - Uses POST requests (not GET) for character search
  - API: https://www.yoyoacc.com/api/game/searchPlayer
  - Character data: https://www.yoyoacc.com/api/game/getResource
  - No proxy needed - direct API access works
  - Aligned to the catalog-wuwa-multi golden standard (catalog-base template)
*/
(function(){
  /* ====== API Sources Declaration ====== */
  const API_SOURCES = {
    'gi_resource': { name: 'GI Resource API', enabled: true },
    'gi_search': { name: 'GI Search API', enabled: true }
  };

  const GI_RESOURCE_API = 'https://www.yoyoacc.com/api/game/getResource';
  const GI_SEARCH_API = 'https://www.yoyoacc.com/api/game/searchPlayer';
  const BATCH_SIZE = 20;
  const PAGE_LIMIT = 20;

  let selected = {};
  let characterData = {};
  let characterList = [];

  let allSearchResults = [];
  let renderedCount = 0;
  let currentPage = 0;
  let currentSearchParams = null;
  let hasMoreApiPages = false;
  let isLoadingMore = false;
  let resultObserver = null;

  // Settings & Translations Initialization
  let giSettings = {translations_json: '{}', images_json: '{}', api_toggles: {}};
  try {
    const el = document.getElementById('catalog-genshinimpact-settings');
    if (el) giSettings = JSON.parse(el.textContent);
  } catch(e) {
    console.error('[GI] Failed to parse settings:', e);
    giSettings = {translations_json: '{}', images_json: '{}', api_toggles: {}};
  }

  // Override API_SOURCES enabled state from admin settings
  if (giSettings.api_toggles) {
    Object.keys(API_SOURCES).forEach(apiId => {
      if (giSettings.api_toggles.hasOwnProperty(apiId)) {
        API_SOURCES[apiId].enabled = giSettings.api_toggles[apiId] === true;
      }
    });
  }

  const enableApiCalls = API_SOURCES.gi_resource.enabled && API_SOURCES.gi_search.enabled;

  var nameTranslationsMap = GachaUtils.buildTranslationMap(giSettings.translations_json);
  var customImagesMap = GachaUtils.buildImageMap(giSettings.images_json);

  const translateName = name => nameTranslationsMap[name] || name;
  const getCustomImage = name => customImagesMap[name] || null;
  const translateServer = (id) => ({1:'America',2:'Europe',3:'Asia',4:'TW/HK/MO'}[String(id)] || `Server ${id}`);

  // ID obfuscation (V2 — provider YO + game GI)
  function privateToPublicID(privateID) {
    if (!privateID) return '';
    return GachaUtils.obfuscateIdV2(privateID, 'YO', 'GI');
  }

  function publicToPrivateID(publicID) {
    return GachaUtils.deobfuscateIdV2(publicID);
  }

  var showToast = GachaUtils.showToast;
  var hideToast = GachaUtils.hideToast;

  var copyToClipboard = function(text) {
    GachaUtils.copyToClipboard(text, 'ID copied! Please share this with customer service to get price quotation.');
  };

  function updateSelectedUI() {
    const total = Object.values(selected).reduce((sum, sel) => sum + (sel.count || 0), 0);
    const el = document.querySelector("#selectedCount");
    if (el) el.textContent = total;
  }

  function updateThumbDisplay(thumb, id) {
    const count = selected[id]?.count || 0;
    const badge = thumb.querySelector('.count-badge');
    if (count > 0) {
      thumb.classList.add('selected');
      if (badge) badge.textContent = count;
      else {
        const b = document.createElement('div');
        b.className = 'count-badge';
        b.textContent = count;
        thumb.querySelector('.thumb-img-container').appendChild(b);
      }
    } else {
      thumb.classList.remove('selected');
      if (badge) badge.remove();
    }
  }

  function clearSelection() {
    selected = {};
    document.querySelectorAll('.thumb').forEach(thumb => {
      thumb.classList.remove('selected');
      const badge = thumb.querySelector('.count-badge');
      if (badge) badge.remove();
    });
    updateSelectedUI();
  }

  function renderFilterUI() {
    const container = document.querySelector("#filters");
    if (!container) return;
    container.innerHTML = '';
    if (!characterList.length) {
      container.innerHTML = '<div class="no-data">No character data.</div>';
      return;
    }
    characterList.forEach(char => {
      const thumb = document.createElement('div');
      thumb.className = 'thumb';
      thumb.dataset.characterId = char.id;

      const displayName = translateName(char.englishName);
      const customImg = getCustomImage(char.englishName);
      const displayImg = customImg || char.img;

      thumb.innerHTML = `
        <div class="thumb-img-container">
          <img alt="${GachaUtils.escapeHtml(displayName)}" src="${GachaUtils.escapeHtml(displayImg)}" loading="lazy"/>
          ${char.featured ? '<div class="featured-badge">UP</div>' : ''}
        </div>
        <div class="label">${GachaUtils.escapeHtml(displayName)}</div>
      `;
      thumb.onclick = () => {
        const id = thumb.dataset.characterId;
        if (selected[id]) {
          selected[id].count++;
        } else {
          selected[id] = { count: 1, name: displayName, img: displayImg, originalName: char.englishName };
        }
        updateThumbDisplay(thumb, id);
        updateSelectedUI();
      };
      container.appendChild(thumb);
    });
    updateSelectedUI();
  }

  function loadResources() {
    // Show API status banner if disabled
    const disabledApis = Object.entries(API_SOURCES).filter(([id, api]) => !api.enabled).map(([id, api]) => api.name);
    if (disabledApis.length > 0) {
      const searchSection = document.querySelector("#gi01");
      if (searchSection) {
        const banner = document.createElement('div');
        banner.style.cssText = 'background: #fef3c7; border: 2px solid #f59e0b; border-radius: 8px; padding: 12px 16px; margin: 16px 0; color: #92400e; font-weight: 500; text-align: center;';
        banner.innerHTML = `⚠️ API calls are currently disabled. Search functionality is temporarily unavailable. Please contact Gachamacha support for assistance.`;
        searchSection.insertBefore(banner, searchSection.firstChild);
      }
    }

    const resultsEl = document.querySelector("#results");
    if (resultsEl) resultsEl.innerHTML = '<div class="loading">🔍 Loading character data...</div>';

    if (!API_SOURCES.gi_resource.enabled) {
      if (resultsEl) resultsEl.innerHTML = '<div class="no-data">⚠️ API calls are currently disabled.<br><br>Please contact Gachamacha support for assistance.</div>';
      return;
    }

    fetch(GI_RESOURCE_API)
      .then(r => r.ok ? r.json() : Promise.reject(`HTTP ${r.status}`))
      .then(response => {
        const innerData = JSON.parse(response.data);
        characterData = {};

        // Load characters from avas array
        innerData.avas.forEach(item => {
          characterData[item.id] = {
            id: item.id,
            englishName: item.lang.EN,
            chineseName: item.lang.CHS,
            level: item.lv,
            featured: item.up,
            rarity: item.lv,
            img: `https://yoyoacc.com/genshin/static/img/res/${item.id}.png`,
            isWeapon: false
          };
        });

        // Load weapons from Weapons array
        if (innerData.Weapons) {
          innerData.Weapons.forEach(item => {
            characterData[item.id] = {
              id: item.id,
              englishName: item.lang.EN,
              chineseName: item.lang.CHS,
              level: item.lv,
              featured: item.up,
              rarity: item.lv,
              img: `https://yoyoacc.com/genshin/static/img/res/${item.id}.png`,
              isWeapon: true
            };
          });
        }

        // Only 5-star characters are selectable in the filters (4-star hidden)
        const allItems = Object.values(characterData);
        const characters = allItems.filter(item => !item.isWeapon && item.rarity === 5);
        const fiveStarWeapons = allItems.filter(item => item.isWeapon && item.rarity === 5);

        // Sort each group by rarity/featured
        characters.sort((a, b) => (b.rarity || 0) - (a.rarity || 0));
        fiveStarWeapons.sort((a, b) => (b.rarity || 0) - (a.rarity || 0));

        // Combine: characters first, then 5-star weapons
        characterList = [...characters, ...fiveStarWeapons];

        renderFilterUI();
        if (resultsEl) resultsEl.innerHTML = '<div class="no-data">Select characters/weapons to search for accounts</div>';
      })
      .catch(err => {
        console.error("[GI] Load failed:", err);
        const container = document.querySelector("#filters");
        if (container) container.innerHTML = '<div class="no-data">Failed to load character list.</div>';
        if (resultsEl) resultsEl.innerHTML = '<div class="no-data">Failed to load character list.</div>';
      });
  }

  // Fetch pages of raw results until we have `targetCount` accounts matching the selected server
  async function fetchFilteredPage(baseParams, startPage, targetCount) {
    const collected = [];
    let page = startPage;
    let hasMore = true;
    while (collected.length < targetCount && hasMore && page <= 20) {
      const params = Object.assign({}, baseParams, { page: page, limit: PAGE_LIMIT });
      const response = await fetch(GI_SEARCH_API, {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify(params)
      });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const data = await response.json();
      const innerData = JSON.parse(data.data);
      const rawAccounts = innerData.data || [];

      const filtered = rawAccounts.filter(p => {
        if (!baseParams.svr) return true;
        return parseInt(p.svr) === baseParams.svr;
      });
      collected.push(...filtered);

      if (rawAccounts.length < PAGE_LIMIT) hasMore = false;
      page++;
    }
    return { accounts: collected, lastPage: page - 1, hasMore: hasMore };
  }

  async function performSearch() {
    const resultsEl = document.querySelector("#results");
    if (!resultsEl) return;
    if (!Object.keys(selected).length) {
      resultsEl.innerHTML = '<div class="no-data">No selection.</div>';
      return;
    }

    // Check if API calls are disabled
    if (!enableApiCalls) {
      resultsEl.innerHTML = '<div class="no-data">⚠️ API calls are currently disabled.<br><br>Please contact Gachamacha support for assistance.</div>';
      showToast('⚠️ API calls are currently disabled', 3000);
      return;
    }

    const searchBtn = document.querySelector("#searchBtn");
    if (searchBtn) {
      searchBtn.disabled = true;
      searchBtn.textContent = 'Searching...';
    }

    resultsEl.innerHTML = '<div class="loading">Searching...</div>';

    const serverSelect = document.querySelector('#serverSelect');
    const selectedServer = serverSelect ? serverSelect.value : '';

    const uaArray = Object.keys(selected).map(id => parseInt(id));
    const baseParams = {
      page: 1, limit: PAGE_LIMIT, ara: false, aua: false, sex: null, rac: null, ra: [],
      uac: null, ua: uaArray, oac: null, oa: [], w: [], nlv: null, xlv: null,
      np: null, xp: null, naf: null, xaf: null, nif: null, xif: null,
      frc: null, fwc: null, ssr: null, cly: null, ssrMax: null
    };
    if (selectedServer !== '') baseParams.svr = parseInt(selectedServer);

    if (!API_SOURCES.gi_search.enabled) {
      resultsEl.innerHTML = '<div class="no-data">⚠️ API calls are currently disabled.<br><br>Please contact Gachamacha support for assistance.</div>';
      if (searchBtn) {
        searchBtn.disabled = false;
        searchBtn.textContent = 'Search';
      }
      return;
    }

    try {
      // Reset state for new search
      currentPage = 0;
      allSearchResults = [];
      renderedCount = 0;
      hasMoreApiPages = false;
      currentSearchParams = baseParams;

      const result = await fetchFilteredPage(baseParams, 1, BATCH_SIZE);

      if (result.accounts.length === 0) {
        hideToast();
        resultsEl.innerHTML = '<div class="no-data">No matching accounts found.</div>';
        return;
      }

      allSearchResults = result.accounts;
      currentPage = result.lastPage;
      hasMoreApiPages = result.hasMore;

      renderResults();
      GachaUtils.scrollToResults('#results');
      hideToast();
    } catch (err) {
      console.error('[GI] Search failed:', err);
      resultsEl.innerHTML = '<div class="no-data">Search failed. Please try again.</div>';
      hideToast();
    } finally {
      if (searchBtn) {
        searchBtn.disabled = false;
        searchBtn.textContent = 'Search';
      }
    }
  }

  function renderResults() {
    const resultsEl = document.querySelector("#results");
    if (!resultsEl) return;
    resultsEl.innerHTML = '';
    renderBatch();
  }

  function renderBatch() {
    const res = document.querySelector("#results");
    if (!res) return;

    const nextBatch = allSearchResults.slice(renderedCount, renderedCount + BATCH_SIZE);

    nextBatch.forEach(account => {
      const card = document.createElement("div");
      card.className = "result-card";

      const accountChars = account.list || [];
      const charCounts = {};
      const charDataMap = {};
      accountChars.forEach(char => {
        const id = char.id;
        if (!charCounts[id]) {
          charCounts[id] = 0;
          charDataMap[id] = char;
        }
        charCounts[id]++;
      });

      const uniqueChars = Object.keys(charCounts).map(id => ({
        ...charDataMap[id],
        count: charCounts[id]
      })).sort((a, b) => (b.star || 0) - (a.star || 0));

      const charHTML = GachaUtils.buildCharGridHTML(uniqueChars.map(c => {
        const charInfo = characterData[c.id] || (GENSHEIN_WEAPON_NAMES[c.id] ? { englishName: GENSHEIN_WEAPON_NAMES[c.id] } : null);
        const displayName = charInfo ? translateName(charInfo.englishName) : `ID: ${c.id}`;
        const customImg = charInfo ? getCustomImage(charInfo.englishName) : null;
        const displayImg = customImg || (charInfo && charInfo.img) || `https://yoyoacc.com/genshin/static/img/res/${c.id}.png`;
        return { name: displayName, img: displayImg, count: c.count, star: c.star };
      }), { translateName: translateName, getCustomImage: getCustomImage, isCatalogItem: (c) => (c.star || 0) >= 5 });

      const serverName = translateServer(account.svr);
      const displayId = privateToPublicID(account.id || '');

      const charString = uniqueChars.map(c => {
        const charInfo = characterData[c.id] || (GENSHEIN_WEAPON_NAMES[c.id] ? { englishName: GENSHEIN_WEAPON_NAMES[c.id] } : null);
        return charInfo ? translateName(charInfo.englishName) : `ID: ${c.id}`;
      }).join(',');
      const extendedId = `${displayId}----${serverName}----[${charString}]`;

      let genderText = 'Unknown';
      if (account.hasOwnProperty('sex')) {
        const sexVal = parseInt(account.sex);
        if (sexVal === 1) genderText = 'Male';
        else if (sexVal === 2) genderText = 'Female';
      }

      const infoItems = [`Server: ${serverName}`, `Gender: ${genderText}`, `Level: ${account.lv || 'N/A'}`];
      const infoString = infoItems.join(' | ');

      card.innerHTML = GachaUtils.buildResultHeaderHTML({ displayId: displayId }) + `
<div class="result-info">${infoString}</div>
<div class="chars-row">
    ${charHTML}
</div>`;

      GachaUtils.wireResultHeaderButtons(card, {
        onCopy: () => copyToClipboard(extendedId),
        onPriceCheck: () => window.showPriceCheck(displayId, extendedId)
      });

      res.appendChild(card);
    });

    renderedCount += nextBatch.length;
    if (renderedCount < allSearchResults.length || (hasMoreApiPages && !isLoadingMore)) {
      GachaUtils.observeLastResultCard(res, resultObserver);
    }
  }

  async function loadMoreAccounts() {
    if (isLoadingMore) return;
    isLoadingMore = true;

    try {
      const result = await fetchFilteredPage(currentSearchParams, currentPage + 1, BATCH_SIZE);

      if (result.accounts.length === 0) {
        hasMoreApiPages = false;
        isLoadingMore = false;
        return;
      }

      allSearchResults.push(...result.accounts);
      currentPage = result.lastPage;
      hasMoreApiPages = result.hasMore;

      renderBatch();
    } catch (err) {
      console.error('[GI] Failed to load more accounts:', err);
    }

    isLoadingMore = false;
  }

  const initResultObserver = () => {
    if (resultObserver) resultObserver.disconnect();
    resultObserver = GachaUtils.createSentinelObserver({
      hasMoreBatch: function() { return renderedCount < allSearchResults.length; },
      hasMoreApi: function() { return hasMoreApiPages && !isLoadingMore; },
      onBatch: function() { renderBatch(); },
      onLoadMore: function() { loadMoreAccounts(); }
    });
  };

  const initPriceModal = () => GachaUtils.initPriceModal({ copyToClipboard });
  window.showPriceCheck = GachaUtils.showPriceCheck;

  document.querySelector("#clearBtn")?.addEventListener('click', clearSelection);
  document.querySelector("#searchBtn")?.addEventListener('click', performSearch);
  window.copyToClipboard = copyToClipboard;
  initResultObserver();
  initPriceModal();
  loadResources();
})();
